import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { backend_url as backendUrl } from './config/variables';
import { Options } from './interfaces/Options';

// // Define the interface for options
// interface Options {
//   method?: 'get' | 'post' | 'put' | 'delete' | 'patch', // You can add other HTTP methods if needed
//   data?: any,
//   headers?: Record<string, string>, // More specific type for headers
//   responseType?: ResponseType, // Properly typed responseType
// }

// The makeRequest function
const makeRequest = async (
  endpoint: string, 
  { method = 'get', data = null, headers = {}, responseType = 'json' as ResponseType }: Options = {}
): Promise<AxiosResponse<any>> => {
  try {
    const response = await axios({
      method,
      url: `${backendUrl}/${endpoint}`,
      data,
      headers,
      responseType, // Explicit ResponseType is used here
    });

    return response;
  } catch (error: any) {
    // Hito 1 (candado): sin sesión la API responde 401. webet no tiene login
    // propio, así que mandamos al login de la API y volvemos a esta misma
    // página. El candado evita redirigir dos veces mientras cambia la URL.
    if (error.response?.status === 401 && typeof window !== 'undefined') {
      const w = window as any;
      if (!w.__bepetizRedirigiendoLogin) {
        w.__bepetizRedirigiendoLogin = true;
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.assign(`/api/auth/login?next=${next}`);
      }
      return new Promise<AxiosResponse<any>>(() => {}); // la página se va; no propagar el error
    }
    console.error('Request Failed: ', error.response ? error.response.data : error.message);
    throw error;
  }
};

export { makeRequest };
